import * as React from "react";
import Image from "antd/es/image";
import { Chains } from "./types";
import { optionsProps } from "./constants";

export interface RecipientIconProps {
    chain: Chains;
    size?: number;
}

export const RecipientIcon: React.FunctionComponent<RecipientIconProps> = (props) => {
    const width = props.size ? `${props.size}px` : optionsProps.width;
    const height = props.size ? `${props.size}px` : optionsProps.height;
    const sizes = { width, height };
    const modifiedProps = {
        ...optionsProps,
        ...sizes,
    };
    switch (props.chain) {
        case "Ethereum":
            return <Image src={require("../ethereum.svg").default} {...modifiedProps} />;
        case "Liberland":
            return <Image src={require("../logo-small.png")} {...modifiedProps} />;
        case "Solana":
            return <Image src={require("../solana.svg").default} {...modifiedProps} />;
        case "Tron":
            return <Image src={require("../tron.svg").default} {...modifiedProps} />;
    }
};
